import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/app/App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// import { Provider } from 'react-redux';
// import { createStore, combineReducers, applyMiddleware } from 'redux';
// import dotsReducer from './store/reducers/dotsUpdate';

// const rootReducer = combineReducers({
//   kuku: dotsReducer,
// });

// // middleware - between action and reducer
// const logger = store => {
//   return next => {
//     return action => {
//       console.log('[Middleware]', action);
//       const result = next(action);
//       return result;
//     };
//   };
// };

// const store = createStore(rootReducer);

// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
